import { render, staticRenderFns } from "./pc-dropdown.vue?vue&type=template&id=5eaf9974&scoped=true&"
import script from "./pc-dropdown.vue?vue&type=script&lang=ts&"
export * from "./pc-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./pc-dropdown.vue?vue&type=style&index=0&id=5eaf9974&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaf9974",
  null
  
)

export default component.exports